import { classNames } from '~/utils/styles';
import type { FormRowProps } from '.';

export function FormRow({ children, className, ...props }: FormRowProps) {
  return (
    <div className={classNames('flex flex-col gap-3 *:grow md:flex-row', className)} {...props}>
      {children}
    </div>
  );
}
